<template>
  <div>
    <div class="ma-2">
      <v-btn
        color="primary"
        class="mb-2"
        @click="openDialog()"
        id="versions-management__open-dialog"
        :disabled="!isPermitted(PermissionEnum.ADMIN.UPDATE_ALL)"
        >{{ $t("modules.admin.versionManagement.add") }}</v-btn
      >
    </div>
    <v-dialog
      v-model="dialog"
      max-width="500px"
      persistent
      id="versions-management__dialog"
    >
      <v-card>
        <v-form
          v-model="valid"
          ref="versionsManagementForm"
          @submit.prevent="save()"
        >
          <v-card-title>
            <span class="headline" id="versions-management__form-title">{{
              $t("modules.admin.versionManagement.add")
            }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-file-input
                    v-model="version_definition"
                    :label="$t('modules.admin.versionManagement.metaFile')"
                    id="versions-management__form-metafile"
                    :rules="metaFileRules"
                    :error="fileError"
                    :error-messages="errorMessages"
                  ></v-file-input>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              text
              elevation="1"
              @click="close"
              id="versions-management__cancel"
              >{{ $t("actions.cancel") }}</v-btn
            >
            <v-btn
              color="secondary"
              text
              elevation="1"
              type="submit"
              :loading="is_loading"
              :disabled="is_loading_global || fileError"
              id="versions-management__save"
              >{{
                editedIndex === -1 ? $t("actions.add") : $t("actions.save")
              }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { handleError } from "@/utils/error";
import { permissionMixin } from "@/mixins/permissions";

export default {
  name: "VersionsManagementAction",
  mixins: [permissionMixin],
  data() {
    return {
      valid: false,
      fileError: false,
      errorMessages: [],
      formData: null,
      metaFileRules: [
        v =>
          !!v ||
          this.$t("validation.required", [
            this.$t("modules.admin.versionManagement.metaFile")
          ])
      ]
    };
  },
  computed: {
    versionsDefinitions() {
      return this.$store.state.versionsDefinitions.versionsDefinitions;
    },
    dialog: {
      get() {
        return this.$store.state.versionsManagement.dialog;
      },
      set(val) {
        this.$store.dispatch("versionsManagement/toggleDialog", val);
      }
    },
    editedItem() {
      return this.$store.state.versionsManagement.editedItem;
    },
    editedIndex() {
      return this.$store.state.versionsManagement.editedIndex;
    },
    version_definition: {
      get() {
        return this.$store.state.versionsManagement.editedItem
          .version_definition;
      },
      set(val) {
        this.$store.commit("versionsManagement/updateVersionDefinition", val);
      }
    },
    search: {
      get() {
        return this.$store.state.versionsManagement.search;
      },
      set(val) {
        this.$store.commit("versionsManagement/updateSearch", val);
      }
    },
    is_loading() {
      return this.$store.state.loader.is_loading;
    },
    is_loading_global() {
      return this.$store.state.loader.is_loading_global;
    }
  },

  watch: {
    version_definition: {
      handler(val) {
        if (val) {
          let reader = new FileReader();
          reader.onload = e => {
            let contents = e.target.result;
            let jsonObject = this.validateJSON(contents);
            this.fileError = jsonObject === false;
            if (this.fileError) {
              this.errorMessages[0] = this.$t(
                "modules.admin.versionManagement.invalidFile"
              );
            } else {
              this.formData = jsonObject;
              this.errorMessages = [];
            }
          };
          reader.onerror = e => {
            this.fileError = true;
          };
          reader.readAsText(val);
        }
      }
    }
  },

  methods: {
    openDialog() {
      this.$store.commit("versionsManagement/updateIndex", -1);
      this.$store.dispatch("versionsManagement/toggleDialog", true).then(() => {
        this.$refs.versionsManagementForm.resetValidation();
      });
    },

    save() {
      if (this.$refs.versionsManagementForm.validate()) {
        this.$store.dispatch("loader/startLoading");
        let data = {
          formData: this.formData
        };
        this.$store.dispatch("versionsManagement/add", data).catch(error => {
          handleError(error, [this.formData["device_model"]]);
        });
      }
    },

    validateJSON(jsonString) {
      try {
        let jsonObject = JSON.parse(jsonString);
        if (jsonObject && typeof jsonObject === "object") {
          return jsonObject;
        }
      } catch (e) {
        return false;
      }
    },

    close() {
      this.$store
        .dispatch("versionsManagement/toggleDialog", false)
        .then(response => {
          this.$refs.versionsManagementForm.resetValidation();
          this.$store.dispatch("versionsManagement/clearForm");
          this.$store.commit("versionsManagement/updateIndex", -1);
        });
    }
  }
};
</script>

<style></style>
